// extracted by mini-css-extract-plugin
export default {"container":"homeMobile_container__Q+UhY","header":"homeMobile_header__hptO2","body":"homeMobile_body__MI9p8"};